import React, { useState } from "react";
import * as Fa from "react-icons/fa";
import { format, subDays } from "date-fns";
import XLSX from "xlsx";
import { toast } from "react-toastify";
import storage from "../../../Services/Storage";
import {
    EndpointCreditMReports,
    createAPIEndpointCreditMReports,
} from "../../../Services/ReportsAll/CreditManagementReports";
import { Calendar } from "primereact/calendar";
import { GetDateFormat } from "../../../Services/GlobalFunc/DateFormat";

const CreditNoteAdjustment = () => {
    // const currentDate = format(new Date(), "yyyy-MM-dd");
    const date = subDays(new Date(), 7);
    // const sevenDays = format(date, "dd/MM/yyy");
    const [fromDate, setFromDate] = useState(date);
    const [toDate, setToDate] = useState(new Date());
    const [loadingExcel, setLoadingExcel] = useState(false);

    // console.log("fromDate",fromDate);

    const handleExportExcel = (fromDate, toDate) => {
    // console.log(fromDate);
    // console.log(toDate);
        const auth = storage.getLocal("user");
    
        const fDate = new Date(fromDate);
        const fromDateRange = format(fDate, "dd/MM/yyyy");
        const tDate = new Date(toDate);
        const toDateRange = format(tDate, "dd/MM/yyyy");
        let daycount = Math.round(
            (toDate.getTime() - fromDate.getTime()) / (1000 * 3600 * 24)
        );
        if (daycount > 90) {
            toast.warning("Date range should not be greater than 90 days.", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            return;
        }
        setLoadingExcel(true);
        let uniqueNo = `CreditNoteAdjReport${GetDateFormat()}`;
        createAPIEndpointCreditMReports()
            .get(
                `${EndpointCreditMReports.GetExcelCreditAdjData}?sFromDate=${fromDateRange}&sToDate=${toDateRange}&CompId=${auth.CompId}`
            )
            .then((val) => {
                if (val.data.length > 0) {
                    var wb = XLSX.utils.book_new();
                    let MapData = val.data.map((val) => {
                        function transformDate(dateString) {
                            if (!dateString) return "";
                            var newData = dateString.replace(/(\d+[/])(\d+[/])/, "$2$1");
                            return new Date(newData);
                        }
                        var data1 = transformDate(val["CN Upload Date"]);
                        var data2 = transformDate(val["Credit Note Date"]);
                        var data3 = transformDate(val["Document Date"]);
                        return {
                            ...val,
                            "CN Upload Date": data1,
                            "Credit Note Date": data2,
                            "Document Date": data3,
                        };
                    });
                    var ws = XLSX.utils.json_to_sheet(MapData);
                    XLSX.utils.book_append_sheet(wb, ws, uniqueNo);
                    XLSX.writeFile(wb, `${uniqueNo}.xlsx`);
                } else {
                    toast.warning("No data found between these dates", {
                        position: toast.POSITION.TOP_CENTER,
                        pauseOnFocusLoss: false,
                        closeButton: false,
                        autoClose: 2000,
                    });
                }
                setLoadingExcel(false);
            })
            .catch((err) => {
                toast.error(`${err.response.data.Messege}`, {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
                setLoadingExcel(false);
            });
    };

    return (
        <div className="pt-3">
            <h3 className="py-2">Credit Note Adjustment Report</h3>
            <section className="sales-box">
                <form>
                    <div className="row d-flex justify-content-end align-items-end">
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            <label className="form-label">From Date</label>
                            <Calendar
                                onChange={(e) => {
                                    setFromDate(e.target.value);
                                }}
                                showIcon
                                value={fromDate}
                                min="2010-01-01"
                                dateFormat="dd/mm/yy"
                            />
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            <label className="form-label">To Date</label>
                            <Calendar
                                value={toDate}
                                onChange={(e) => setToDate(e.value)}
                                showIcon
                                min="2010-01-01"
                                dateFormat="dd/mm/yy"
                            />
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            <div className="text-end">
                                <button
                                    disabled={loadingExcel}
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => {
                                        handleExportExcel(fromDate, toDate);
                                    }}
                                >
                                    {loadingExcel ? "Loading..." : "Save As Excel"}
                                    {loadingExcel ? (
                                        <span
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                            aria-hidden="true"
                                        ></span>
                                    ) : (
                                        <Fa.FaDownload className="ms-2" />
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </section>
        </div>
    );
};

export default CreditNoteAdjustment;
